import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
	platformBrowserDynamic()
		.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
		.catch((err) => console.error(err));
});

// if we need to hide the developers console log, just uncomment the below code

if(environment.production){
	 window.console.log = function(){};
	  window.console.error = function(){};
	 window.console.warn = function(){};
}